import React from "react";
import Game from "./Game";
import { render, getConfig, assetsUrl, GameProvider, initErrorMonitoring } from "@educaplay/core";
import { initialize } from "@educaplay/store";
import { createCustomization } from "@educaplay/core/utils/customization";
import ResultsScreen from "./resultComponents/ResultsScreen";

const gameImage = assetsUrl("RELACIONAR_COLUMNAS/logoActivity.webp");
const container = document.getElementById("root");
const MAX_POINTS = 100;

initErrorMonitoring("https://00b13f1569299cc016342737a2cc4504@o4509038211104768.ingest.de.sentry.io/4510702154743888", {
  tracesSampleRate: 0.05
});

const RELACIONAR_COLUMNAS_SOUNDS = {
  "relacionar-columnas-active": assetsUrl("RELACIONAR_COLUMNAS/activo.mp3"),
  "relacionar-columnas-correct": assetsUrl("RELACIONAR_COLUMNAS/correcto.mp3"),
  "relacionar-columnas-hover": assetsUrl("RELACIONAR_COLUMNAS/hover.mp3"),
  "relacionar-columnas-move": assetsUrl("RELACIONAR_COLUMNAS/mover.mp3"),
};

async function init() {
  const { data, texts, settings, user, title, description, author, id, url } =
    await getConfig().catch((err) =>
      console.error("Error al obtener la configuración: ", err)
    );

  const PairWithContent = (a) =>
    (a?.RESPUESTA?.trim() ?? "") !== "" ||
    (a?.MULTIMEDIA?.trim() ?? "") !== "";

  const questionwithoutValidPair = (q) =>
    Array.isArray(q?.RESPUESTAS) &&
    q.RESPUESTAS.length === 2 &&
    q.RESPUESTAS.every(PairWithContent);

  const screens = data.BLOQUES.filter(
    (screen) =>
      Array.isArray(screen?.PREGUNTAS) &&
      screen.PREGUNTAS.some(questionwithoutValidPair)
  ).map((question, index) => ({ ...question, screenID: index }));


  const { resources } = settings;

  const questionTimeNumber = Number(data.TIEMPO);
  const questionTime = Number.isNaN(questionTimeNumber)
    ? 0
    : questionTimeNumber;

  const numQuestions = screens.reduce(
    (acc, questionBlock) => acc + questionBlock.PREGUNTAS.length,
    0
  );
  let questionIndex = -1;

  const questions = screens.flatMap((screen) => {
    const screenQuestions = screen.PREGUNTAS;

    return screenQuestions.map((question) => {
      questionIndex++;
      const left = question.RESPUESTAS[0];
      const right = question.RESPUESTAS[1];
      const questionPoints = MAX_POINTS / numQuestions;
      const cardPoints = questionPoints / 2;
      const leftImageFormatted =
        left.MULTIMEDIA !== undefined ? `${resources}${left.MULTIMEDIA}` : null;
      const rightImageFormatted =
        right.MULTIMEDIA !== undefined
          ? `${resources}${right.MULTIMEDIA}`
          : null;

      const checkAnswer = (answer) => {
        return answer.left === answer.right;
      };

      const calculateSidePoints = (failed, cardPoints) => {
        if (failed === 0) return cardPoints;
        if (failed === 1) return cardPoints / 2;
        if (failed === 2) return cardPoints / 4;
        return 0;
      };

      const calculatePoints = (answer) => {
        const { left, right } = answer.tries;
        const sumPoints = calculateSidePoints(left, cardPoints) + calculateSidePoints(right, cardPoints);
        return sumPoints;
      };


      const leftElement = {
        media: leftImageFormatted
          ? {
            value: leftImageFormatted,
            type: left.MULTIMEDIA_TIPO,
          }
          : false,
        value: left.RESPUESTA,
      };

      const rightElement = {
        media: rightImageFormatted
          ? {
            value: rightImageFormatted,
            type: right.MULTIMEDIA_TIPO,
          }
          : false,
        value: right.RESPUESTA,
      };

      return {
        checkAnswer,
        answer: null,
        id: questionIndex,
        calculatePoints,
        leftElement,
        rightElement,
        time: questionTime,
        screenId: screen.screenID,
        points: questionPoints,
      };
    });
  });

  initialize({
    lives: data.NUMERO_INTENTOS, //COMPROBAR SI ES MAXIMO
    liveActived: data.NUMERO_INTENTOS_INFINITOS !== "si",
    hasCountDown: data.MAXIMO === "si",
    randomized: data.ALEATORIO === "si",
    showSolutions: data.OCULTAR_RESPUESTAS !== "1",
    showRestart: data.OCULTAR_REINICIAR !== "1",
    showSocialMedia: data.OCULTAR_REDES !== "1",
    finalText: data.TEXTO_FINAL,
    countFooterSpace: true,
    hasBank: false,
    hasInfinityTries: true,
    questions,
    settings,
    title,
    description,
    author,
    id,
    url,
    user,
    customizations: createCustomization({
      ...data,
      showBackgroundInGame: true,
    }),
  });

  render(
    container,
    <React.StrictMode>
      <GameProvider
        gameImage={gameImage}
        texts={texts}
        Game={Game}
        mappers={{
          report: (question) => {
            if (!question.answer) return [];
            const isCorrect = question.checkAnswer(question.answer);
            const tries = question.tries;
            const screenId = question.screenId;
            const reports = [];

            tries.forEach((attempt) => {
              reports.push({
                s: 0,
                i: `${screenId}:${attempt.left}:0`,
                a: `${screenId}:${attempt.right}:1`,
              })
            });

            reports.push({
              s: isCorrect ? 1 : 0,
              i: `${screenId}:${question.answer.left}:0`,
              a: `${screenId}:${question.answer.right}:1`,
            });
            return reports;
          }
        }}

        renders={{
          results: (questions) => {
            console.log({ questions })
            const answers = questions.map((question) => {
              console.log({ question })
              return {
                id: question.id,
                correct: question.answer
                  ? question.checkAnswer(question.answer)
                  : false,
                left: question.leftElement,
                right: question.rightElement,
              };
            });

            return <ResultsScreen questions={answers} />;
          },
        }}
        sounds={RELACIONAR_COLUMNAS_SOUNDS}
      />
    </React.StrictMode>
  );
}

init();
